import { Button, Form, Input } from 'antd';
import React from 'react';
import { useColors } from './ColorStore';
import { useForm } from 'antd/es/form/Form';

function Add(props) {
    let [form] = useForm();
    let {createColor} = useColors()
    return (
        <Form form={form} layout="vertical" onFinish={createColor} encType="multipart/form-data">
            <Form.Item label="O'zbekcha nomi" name="nameuz" rules={[{ required: true, message: 'Please input your name!' }]}>
                <Input />
            </Form.Item>
            <Form.Item label="Ruscha nomi" name="nameru" rules={[{ required: true, message: 'Please input your description!' }]}>
                <Input />
            </Form.Item>
            <Form.Item label="Rangi" name="color" rules={[{ required: true, message: 'Please input your color!' }]}>
                <Input type='color' />
            </Form.Item>
            <Form.Item>
                <Button type="primary" htmlType="submit">Qo'shish</Button>
            </Form.Item>
        </Form>
    );
}

export default Add;